export const getActionId = (data) => {
   return {
      type: "GET_ACTION_ID",
      payload: data,
   };
};

export const getMailboxId = (data) => {
   return {
      type: "GET_MAILBOX_ID",
      payload: data,
   };
};
export const setProcessMessage = (message) => {
   return {
      type: "SET_PROCESS_MESSAGE",
      message,
   };
};
export const getComment = (data) => {
   return {
      type: "GET_COMMENT",
      payload: data,
   };
};
export const getSelectedRecipient = (data) => {
   return {
      type: "GET_SELECTED_RECIPIENT",
      payload: data,
   };
};
export const getStepId = (data) => {
   return {
      type: "GET_STEP_ID",
      payload: data,
   };
};

export const setListOfAllUsers = (data) => {
   return {
      type: "SET_ALL_USERS_LIST",
      payload: data,
   };
};

export const setFolderCache = (data) => {
   return {
      type: "SET_FOLDER_CACHE",
      payload: data,
   };
};

export const setShowReturnButton = (data) => {
   return {
      type: "SET_SHOW_RETURN_BUTTON",
      payload: data,
   };
};

export const setMailBoxes = (data) => {
   return {
      type: "SET_USER_MAILBOXES",
      payload: data,
   };
};
export const setIsMailboxAdded = (data) => {
   return {
      type: "SET_IS_MAILBOX_ADDED",
      payload: data,
   };
};

export const fetchAllUsersIfNeeded = (fetchUsers) => async (dispatch, getState) => {
   const slice = getState().messages;

   const { allUsersLoaded, allUsersLoading } = slice || {};
   if (allUsersLoaded || allUsersLoading) return;

   dispatch({ type: "FETCH_ALL_USERS_REQUEST" });
   try {
      const res = await fetchUsers();
      dispatch(setListOfAllUsers(res?.data ?? res));
   } catch (e) {
      dispatch({ type: "FETCH_ALL_USERS_FAILURE", payload: String(e) });
   }
};
